import { use_slice_workspace, use_slice_workspace_billing } from '@/hooks/store/use_slices';
import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { md } from '@/utils/utils_html';
import { DTO__workspace_user } from '@shared/dto/+workspace/workspace_user/DTO__workspace_user';
import { format_compact_number, format_number_with_spaces } from '@shared/utils/utils_number';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { WSTableAllTimeCreditsCell } from './WSTableAllTimeCreditsCell';

interface Props {
  is_coins: boolean;
  users: DTO__workspace_user[];
}

export function WSTableAllTimeCreditsRow({ is_coins, users }: Props) {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);

  const { workspace_current } = use_slice_workspace(['workspace_current']);
  const { credit_transactions_map } = use_slice_workspace_billing(['credit_transactions_map']);

  const [isHovered, setIsHovered] = useState(false);

  const workspace_credits_all = Array.from(credit_transactions_map.values())
    .flatMap(inner_map => Array.from(inner_map.values()))
    .filter(transaction => transaction.workspace_id === workspace_current._id);

  const workspace_credits_total = workspace_credits_all.reduce((acc, transaction) => acc + transaction.value, 0);

  /*
   * RENDERS
   */

  function render_cell_all_time() {
    let value = isHovered ? format_number_with_spaces(workspace_credits_total) : format_compact_number(workspace_credits_total);

    if (workspace_credits_total == 0) {
      //do nothing
    } else if (is_coins) {
      value = '100%';
    }

    return (
      <span
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className={`${md('min-w-[40px] text-[12px]', 'min-w-[100px] h-[50px]')} flex items-center justify-center border-r border-dashed border-component-item`}
      >
        <span className={`${workspace_credits_total == 0 ? 'opacity-50' : ''}`}>{value}</span>
      </span>
    );
  }

  function render_cells() {
    return users.map(user => {
      return (
        <WSTableAllTimeCreditsCell
          key={`WSTableAllTimeCreditsRow-${user._id}`}
          user={user}
          workspace_credits_total={workspace_credits_total}
          workspace_credits_all={workspace_credits_all}
          is_coins={is_coins}
        />
      );
    });
  }

  return (
    <div className={`${md('px-2 justify-start gap-2', ' px-5 justify-start')} w-full min-h-[50px] flex flex-row items-center`}>
      <span className={`${md('min-w-[130px] text-[9px]', 'min-w-[220px]')} text-left`}>
        {t(i18n_page_settings_workspace.tabs.credits_transactions.table.credits_statistic_all_time.row.all_time)}
      </span>
      {render_cell_all_time()}
      {render_cells()}
    </div>
  );
}
